'use strict';
// import modalControllerHistorial from './historial.modal.controller.js';
// import modalTemplateHistorial from './historial.modal.html';
class PagosPromueveController {
  constructor($log, Modal, Storage, $location, baseUrl) {
    'ngInject';

    this.$log = $log;
    this.Modal = Modal;
    this.Storage = Storage;
    this.$location = $location;
    this.baseUrl = baseUrl;
  }

  $onInit() {
    this.cargarTabla();
  }

  cargarTabla(){
    var colors = {
      'RENOVACION': 'success',
      'REGISTRO': 'info-second',
    };
    this.solicitudes = {
      url: `certificacion_promueve/certificaciones/impresiones`,
      data: {
        formly: [
          {
            key: 'id_producto',
            type: 'input',
            templateOptions: {
              label: 'id producto',
              type: 'number'
            }
          },
          {
            key: 'id_unidad_productiva',
            type: 'input',
            templateOptions: {
              label: 'Unidad productiva',
              type: 'number'
            }
          },
          {
            key: 'id_certificacion',
            type: 'input',
            templateOptions: {
              label: 'Certificación',
              type: 'number'
            }
          },
          {
            key: 'id_pago',
            type: 'input',
            templateOptions: {
              label: 'Pago',
              type: 'number'
            }
          },
          {
            key: 'certificacion_pago_estado',
            type: 'input',
            templateOptions: {
              label: 'pago estado',
              type: 'text'
            }
          },
          {
            key: 'data',
            type: 'input',
            templateOptions: {
              label: 'data',
              type: 'number'
            }
          },
          {
            key: 'ruta_imagen',
            type: 'archive',
            templateOptions: {
              label: 'Foto',
              type: 'img'
            }
          },
          {
            key: 'razon_social',
            type: 'input',
            templateOptions: {
              label: 'Razón social',
              type: 'text'
            }
          },
          {
            key: 'nit',
            type: 'input',
            templateOptions: {
              label: 'NIT',
              type: 'text'
            }
          },
          {
            key: 'matricula_comercio',
            type: 'input',
            templateOptions: {
              label: 'Matrícula',
              type: 'text'
            }
          },
          {
            key: 'nombre_producto',
            type: 'input',
            templateOptions: {
              label: 'Producto',
              type: 'text'
            }
          },
          {
            key: 'nro_secuencia',
            type: 'input',
            templateOptions: {
              label: 'MEFP',
              type: 'text'
            },
            class: 'text-center',
            next: {
              key: 'nro_solicitud',
              label: 'Secuencia | Solicitud',
            }
          },
          {
            key: 'nro_solicitud',
            type: 'input',
            templateOptions: {
              label: '# solicitud',
              type: 'Number'
            }
          },
          {
            key: 'pago_fecha_envio',
            type: 'datepicker',
            templateOptions: {
              label: 'Fecha envío',
              type: 'date'
            },
            class: 'text-center',
          },
          {
            key: 'tipo',
            type: 'select',
            templateOptions: {
              label: 'Tipo',
              type: 'select',
              options: [
                {
                  "value": "RENOVACION",
                  "name": "RENOVACIÓN"
                },
                {
                  "value": "REGISTRO",
                  "name": "REGISTRO"
                },
              ]
            }
          },
        ]
      },
      fields: ['id_unidad_productiva', 'id_producto', 'id_certificacion', 'id_pago', 'data', 'ruta_imagen', 'nit', 'razon_social', 'matricula_comercio', 'nombre_producto', 'pago_fecha_envio', 'tipo', 'nro_secuencia', 'nro_solicitud', 'certificacion_pago_estado'],
      hiddenFields: ['id_unidad_productiva', 'id_producto', 'id_certificacion', 'id_pago', 'data', 'nro_solicitud', 'certificacion_pago_estado'],
      fks: ['fid_formulario'],
      permission: {
        create: false,
        update: false,
        delete: false,
        filter: false
      },
      buttons: [
        {
          icon: 'eye',
          tooltip: 'Ver detalles del producto y depósito',
          onclick: (ev, item) => {
            this.verDetalleSolicitud(item);
          }
        },
        // {
        //   icon: 'line-chart',
        //   tooltip: 'Ver historial del producto',
        //   onclick: (ev, item) => {
        //      this.Modal.show({
        //        template: modalTemplateHistorial,
        //        controller: modalControllerHistorial,
        //        data: {
        //          id_producto: item.id_producto
        //        },
        //        size: 'lg'
        //      });

        //   }
        // }
      ],
      clases: {
        'tipo': item => {
          return ['badge', 'badge-'+colors[item.tipo]];
        }
      }
    };
  }

  verDetalleSolicitud(item) {
    const data_form = {
      id_certificacion: item.id_certificacion,
      id_producto: item.id_producto,
      id_unidad_productiva: item.id_unidad_productiva,
      id_pago: item.id_pago,
      certificacion_pago_estado: item.certificacion_pago_estado,
      nit: item.nit,
      razon_social: item.razon_social,
      nombre_producto: item.nombre_producto,
      deposito: item.data.deposito,
      factura: item.data.factura,
    }
    this.Storage.set('print_prod', data_form);
    this.$location.path('impProductoPromueve');
  }
}
export default PagosPromueveController;



// WEBPACK FOOTER //
// ./src/app/components/admin/promueve/pagos/pagos_promueve.controller.js